import dayjs from "dayjs";
import { OrderReceptionSlot } from "@/types";
import { formatSlotRange } from "@/utils/CollectionSlots";

export const formatOrderReceptionSlot = (slot: OrderReceptionSlot): string =>
  `${dayjs(slot.slotDate).format("DD.MM.YYYY")}, ${formatSlotRange(slot)}`;
